import { useResultsSelector } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { useSearchModeForSearchModel } from '#pplx/frontend/apps/ask/search/hooks/useSearchModeForSearchModel.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { MessageHelper } from '#pplx/frontend/components/utils/MessageHelper.js';
/**
 * Whether the current stream can receive an in-context clarification.
 * @returns True for a pending Research or Computer result; false for other modes.
 */
export function useIsStreamingQueryCapableOfClarifyingQuestions() {
    const getSearchModeForSearchModel = useSearchModeForSearchModel();
    // Select the primitive, not the entry: the streaming entry is replaced on
    // every token and would re-render the whole attribution row each time.
    const streamingDisplayModel = useResultsSelector((state) => state.results.find((x) => MessageHelper.isStatusPending(x))?.display_model);
    const streamingSearchMode = getSearchModeForSearchModel(streamingDisplayModel);
    return streamingSearchMode === SearchMode.RESEARCH || streamingSearchMode === SearchMode.ASI;
}
//# sourceMappingURL=useIsStreamingQueryCapableOfClarifyingQuestions.js.map